import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  OFFICES_CONTAINER: `${cleanedFilename(__filename)}-offices-container`,
  USERS_CONTAINER: `${cleanedFilename(__filename)}-users-container`,
};
